(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[484],{

/***/ 90589:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/industry",
      function () {
        return __webpack_require__(82256);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51096);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _components_wrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65409);
/* harmony import */ var _components_seo_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90423);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25838);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81627);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);










var Photo = function(param) {
    var menuDetail = param.menuDetail, data = param.data;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_8__/* .useTranslations */ .T_)("media.industry");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_wrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().container), "m-1600"),
                children: [
                    (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_6__/* .getHead */ .c)(menuDetail),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: t("title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().newsList),
                        children: data === null || data === void 0 ? void 0 : (ref = data.list) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                            var ref, ref1, ref2, ref3, ref4;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: (item === null || item === void 0 ? void 0 : (ref = item.info) === null || ref === void 0 ? void 0 : ref.outlink) || "/media/news/news_detail/".concat(item === null || item === void 0 ? void 0 : item.id),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    target: (item === null || item === void 0 ? void 0 : (ref1 = item.info) === null || ref1 === void 0 ? void 0 : ref1.outlink) ? "_blank" : "",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().newItem),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: item === null || item === void 0 ? void 0 : (ref2 = item.info) === null || ref2 === void 0 ? void 0 : ref2.image,
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        children: item === null || item === void 0 ? void 0 : (ref3 = item.info) === null || ref3 === void 0 ? void 0 : ref3.title
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: item === null || item === void 0 ? void 0 : (ref4 = item.info) === null || ref4 === void 0 ? void 0 : ref4.brief
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: new Date((item === null || item === void 0 ? void 0 : item.publish_time) * 1000).toLocaleString().replace(/\//g, "-").split(" ")[0]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().btn),
                                                        src: "/image/news-bg-btn.png",
                                                        alt: ""
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, item === null || item === void 0 ? void 0 : item.id);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_seo_pagination__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        page: Number(router.query.page || 1),
                        total: data === null || data === void 0 ? void 0 : data.total,
                        size: data === null || data === void 0 ? void 0 : data.list_rows
                    })
                ]
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Photo);


/***/ }),

/***/ 51096:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1600":"industry_m-1600__tmBdh","container":"industry_container__lNjA0","top":"industry_top__zafzb","active":"industry_active__ay64f","newsList":"industry_newsList__yLQET","newItem":"industry_newItem__2YFNm","btn":"industry_btn___gslW"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [330,774,888,179], function() { return __webpack_exec__(90589); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);